import { render, staticRenderFns } from "./about-us.vue?vue&type=template&id=f4042b88"
import script from "./about-us.vue?vue&type=script&lang=js"
export * from "./about-us.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4042b88')) {
      api.createRecord('f4042b88', component.options)
    } else {
      api.reload('f4042b88', component.options)
    }
    module.hot.accept("./about-us.vue?vue&type=template&id=f4042b88", function () {
      api.rerender('f4042b88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/system-management/aboutcontacting-managment/about-us.vue"
export default component.exports